﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpLoanCalc = exports.CmpSmartVaultSelector = exports.CmpSmartVaultSelected = exports.PageDashboard = exports.PageLoading = exports.TopNavBar = exports.ModalDialog = void 0;
const gs = require("@ivanlog/gs");
class ModalDialogControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.container = this._ctrls.get('container');
        this.content = this._ctrls.get('content');
        this.header = this._ctrls.get('header');
        this.textTitle = this._ctrls.get('textTitle');
        this.btnClose = this._ctrls.get('btnClose');
        this.body = this._ctrls.get('body');
        this.footer = this._ctrls.get('footer');
        this.btnOk = this._ctrls.get('btnOk');
        this.btnNo = this._ctrls.get('btnNo');
        this.btnCancel = this._ctrls.get('btnCancel');
    }
}
class ModalDialog extends gs.ComponentGS {
    constructor() {
        super("modalDialog", ModalDialogControls);
    }
}
exports.ModalDialog = ModalDialog;
class TopNavBarControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.label = this._ctrls.get('label');
    }
}
class TopNavBar extends gs.ComponentGS {
    constructor() {
        super("topNavBar", TopNavBarControls);
    }
}
exports.TopNavBar = TopNavBar;
class PageLoadingControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
    }
}
class PageLoading extends gs.ComponentGS {
    constructor() {
        super("pageLoading", PageLoadingControls);
    }
}
exports.PageLoading = PageLoading;
class PageDashboardControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blocks = this._ctrls.get('blocks');
    }
}
class PageDashboard extends gs.ComponentGS {
    constructor() {
        super("pageDashboard", PageDashboardControls);
    }
}
exports.PageDashboard = PageDashboard;
class CmpSmartVaultSelectedControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnToggle = this._ctrls.get('btnToggle');
        this.lSmartVaultId = this._ctrls.get('lSmartVaultId');
        this.lFCR = this._ctrls.get('lFCR');
    }
}
class CmpSmartVaultSelected extends gs.ComponentGS {
    constructor() {
        super("cmpSmartVaultSelected", CmpSmartVaultSelectedControls);
    }
}
exports.CmpSmartVaultSelected = CmpSmartVaultSelected;
class CmpSmartVaultSelectorControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.lSmartVaultId = this._ctrls.get('lSmartVaultId');
        this.lFCR = this._ctrls.get('lFCR');
        this.lICR = this._ctrls.get('lICR');
    }
}
class CmpSmartVaultSelector extends gs.ComponentGS {
    constructor() {
        super("cmpSmartVaultSelector", CmpSmartVaultSelectorControls);
    }
}
exports.CmpSmartVaultSelector = CmpSmartVaultSelector;
class CmpLoanCalcControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.vaultSelected = this._ctrls.get('vaultSelected');
        this.blockVaultSelector = this._ctrls.get('blockVaultSelector');
        this.vaultSelector = this._ctrls.get('vaultSelector');
        this.btnSVInfoToggle = this._ctrls.get('btnSVInfoToggle');
        this.lSVInfoYourLoan = this._ctrls.get('lSVInfoYourLoan');
        this.lSVInfoYourColl = this._ctrls.get('lSVInfoYourColl');
        this.lSVInfoBalancePLSV = this._ctrls.get('lSVInfoBalancePLSV');
        this.blockSVInfoAdditional = this._ctrls.get('blockSVInfoAdditional');
        this.lSVInfoTotalLoan = this._ctrls.get('lSVInfoTotalLoan');
        this.lSVInfoSupplyPLSV = this._ctrls.get('lSVInfoSupplyPLSV');
        this.lSVInfoDiffLoan = this._ctrls.get('lSVInfoDiffLoan');
        this.lSVAddress = this._ctrls.get('lSVAddress');
        this.lSVInfoRedeemIndex = this._ctrls.get('lSVInfoRedeemIndex');
        this.lSVInfoClosing = this._ctrls.get('lSVInfoClosing');
        this.lSVInfoCloseDate = this._ctrls.get('lSVInfoCloseDate');
        this.lSVInfoIsClosed = this._ctrls.get('lSVInfoIsClosed');
        this.blockTabs = this._ctrls.get('blockTabs');
        this.btnTabBorrow = this._ctrls.get('btnTabBorrow');
        this.btnTabRepay = this._ctrls.get('btnTabRepay');
        this.btnTabTransfer = this._ctrls.get('btnTabTransfer');
        this.btnTabClaim = this._ctrls.get('btnTabClaim');
        this.btnTabRedeemCalc = this._ctrls.get('btnTabRedeemCalc');
        this.btnTabPLSV = this._ctrls.get('btnTabPLSV');
        this.blockConnectWallet = this._ctrls.get('blockConnectWallet');
        this.btnConnectWallet = this._ctrls.get('btnConnectWallet');
        this.tabBorrow = this._ctrls.get('tabBorrow');
        this.iDepositValuePLS = this._ctrls.get('iDepositValuePLS');
        this.btnDepositMax = this._ctrls.get('btnDepositMax');
        this.iBorrowValueUSDL = this._ctrls.get('iBorrowValueUSDL');
        this.btnBorrowMax = this._ctrls.get('btnBorrowMax');
        this.btnBorrowSubmit = this._ctrls.get('btnBorrowSubmit');
        this.lTxDepositValue = this._ctrls.get('lTxDepositValue');
        this.lTxDepositLoan = this._ctrls.get('lTxDepositLoan');
        this.lTxDepositFee = this._ctrls.get('lTxDepositFee');
        this.lTxDepositBorrow = this._ctrls.get('lTxDepositBorrow');
        this.tabRepay = this._ctrls.get('tabRepay');
        this.iRepayValueUSDL = this._ctrls.get('iRepayValueUSDL');
        this.btnRepayMax = this._ctrls.get('btnRepayMax');
        this.btnRepaySubmit = this._ctrls.get('btnRepaySubmit');
        this.lTxRepayValue = this._ctrls.get('lTxRepayValue');
        this.lTxRepayColl = this._ctrls.get('lTxRepayColl');
        this.tabTransfer = this._ctrls.get('tabTransfer');
        this.transferVaultSelector = this._ctrls.get('transferVaultSelector');
        this.btnTransferSubmit = this._ctrls.get('btnTransferSubmit');
        this.hidderTransferAdditional = this._ctrls.get('hidderTransferAdditional');
        this.blockTransferAdditional = this._ctrls.get('blockTransferAdditional');
        this.iTransferValueUSDL = this._ctrls.get('iTransferValueUSDL');
        this.btnTransferMax = this._ctrls.get('btnTransferMax');
        this.lTxTransferToAddr = this._ctrls.get('lTxTransferToAddr');
        this.lTxTransferToFCR = this._ctrls.get('lTxTransferToFCR');
        this.lTxTransferAddColl = this._ctrls.get('lTxTransferAddColl');
        this.lTxTransferFee = this._ctrls.get('lTxTransferFee');
        this.lTxTransferFlashLoanFee = this._ctrls.get('lTxTransferFlashLoanFee');
        this.lTxTransferNewLoanAmount = this._ctrls.get('lTxTransferNewLoanAmount');
        this.lTxTransferOwnUsdl = this._ctrls.get('lTxTransferOwnUsdl');
        this.lTxTransferCollReturn = this._ctrls.get('lTxTransferCollReturn');
        this.tabClaim = this._ctrls.get('tabClaim');
        this.btnClaimSubmit = this._ctrls.get('btnClaimSubmit');
        this.lTxClaimValue = this._ctrls.get('lTxClaimValue');
        this.tabRedeemCalc = this._ctrls.get('tabRedeemCalc');
        this.btnCalculateRedeemSubmit = this._ctrls.get('btnCalculateRedeemSubmit');
        this.tabPLSV = this._ctrls.get('tabPLSV');
        this.btnAddPLSV = this._ctrls.get('btnAddPLSV');
        this.iTokenizeValueUSDL = this._ctrls.get('iTokenizeValueUSDL');
        this.btnTokenizeMax = this._ctrls.get('btnTokenizeMax');
        this.btnTokenizeSubmit = this._ctrls.get('btnTokenizeSubmit');
        this.iDetokenizeValueUSDL = this._ctrls.get('iDetokenizeValueUSDL');
        this.btnDetokenizeMax = this._ctrls.get('btnDetokenizeMax');
        this.btnDetokenizeSubmit = this._ctrls.get('btnDetokenizeSubmit');
        this.blockTokenizeOverview = this._ctrls.get('blockTokenizeOverview');
        this.lTokenizeTxLoan = this._ctrls.get('lTokenizeTxLoan');
        this.lTokenizeTxMint = this._ctrls.get('lTokenizeTxMint');
        this.lTokenizeTxFee = this._ctrls.get('lTokenizeTxFee');
        this.blockDetokenizeOverview = this._ctrls.get('blockDetokenizeOverview');
        this.lDetokenizeTxLoan = this._ctrls.get('lDetokenizeTxLoan');
        this.lDetokenizeTxBurn = this._ctrls.get('lDetokenizeTxBurn');
        this.lDetokenizeTxFee = this._ctrls.get('lDetokenizeTxFee');
    }
}
class CmpLoanCalc extends gs.ComponentGS {
    constructor() {
        super("cmpLoanCalc", CmpLoanCalcControls);
    }
}
exports.CmpLoanCalc = CmpLoanCalc;
gs.WrapperGS.InjectComponents(ModalDialog, 'ModalDialog');
gs.WrapperGS.InjectComponents(TopNavBar, 'TopNavBar');
gs.WrapperGS.InjectComponents(PageLoading, 'PageLoading');
gs.WrapperGS.InjectComponents(PageDashboard, 'PageDashboard');
gs.WrapperGS.InjectComponents(CmpSmartVaultSelected, 'CmpSmartVaultSelected');
gs.WrapperGS.InjectComponents(CmpSmartVaultSelector, 'CmpSmartVaultSelector');
gs.WrapperGS.InjectComponents(CmpLoanCalc, 'CmpLoanCalc');
//# sourceMappingURL=tmpls.js.map